import { FC, useEffect, useMemo, useState } from 'react';
import CreateEditLayout from '@features/workspace/components/layouts/sub/create-edit-layout';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import history from '@app/services/history';
import LeaveFormSaveDialog from '@features/workspace/components/dialogs/leave-form-save-dialog';
import { selectNotes } from '@features/workspace/store/selectors';
import { setIsLoading } from '@store/features/loading';
import NoteForm, {
  INIT_DATA,
} from '@features/workspace/views/company/notes/form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import noteSchema from '@features/workspace/schemas/note-schema';
import logger from '@app/services/logger';

const NoteEdit: FC<any> = () => {
  const backUri = '/customer/contact#notes';
  const dispatch = useAppDispatch();

  const notes: any = useAppSelector(selectNotes);

  const { note_id } = useParams();

  const [data, setData] = useState(INIT_DATA);
  const [initData, setInitData] = useState(INIT_DATA);
  const [openLeaveFormSaveDialog, setOpenLeaveFormSaveDialog] = useState(false);

  const existingNote = useMemo(() => {
    return notes?.find((note: any) => note.id === note_id);
  }, [note_id, notes]);

  const { register, handleSubmit, formState, reset, control } = useForm({
    defaultValues: initData,
    resolver: yupResolver(noteSchema),
  });

  const { errors, isDirty } = formState;

  useEffect(() => {
    if (existingNote) {
      const initialState = {
        ...INIT_DATA,
        ..._.omitBy(existingNote, _.isNil),
      };

      setInitData(initialState);
      setData(initialState);
      logger.debug('Init state', initialState);
      reset(initialState);
    }
  }, [reset, existingNote]);

  const onSave = async () => {
    dispatch(setIsLoading(true));

    // TODO: save note integration

    dispatch(setIsLoading(false));
  };

  const goBack = () => {
    history.push(backUri);
  };

  const onGoBack = () => {
    if (isDirty) {
      setOpenLeaveFormSaveDialog(true);
    } else {
      goBack();
    }
  };

  return (
    <CreateEditLayout
      backUri={backUri}
      onBack={onGoBack}
      onCancel={onGoBack}
      onSave={onSave}
    >
      <NoteForm
        control={control}
        data={data}
        errors={errors}
        register={register}
      />
      <LeaveFormSaveDialog
        open={openLeaveFormSaveDialog}
        onAccept={handleSubmit(onSave)}
        onClose={() => setOpenLeaveFormSaveDialog(false)}
        onReject={goBack}
      />
    </CreateEditLayout>
  );
};

export default NoteEdit;
